import { render } from "./EventDetailPage.vue?vue&type=template&id=f780ea78&scoped=true"
import script from "./EventDetailPage.vue?vue&type=script&lang=js"
export * from "./EventDetailPage.vue?vue&type=script&lang=js"

import "./EventDetailPage.vue?vue&type=style&index=0&id=f780ea78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f780ea78"]])

export default __exports__